import { ENDPOINT } from "../utils/constants";
import { getServerUrl, oAuthRequest, request } from '../utils/request';

export const getStepInfo = (stepId,stepType) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.UTILS}/step/${stepId}/${stepType}`,
        method: 'get',
    });

}

export const getLearningPathStepById = async (id, type) => {
    const response = await request({
        params: {
            nestedFields: type
        },
        url:`${ENDPOINT.LEARNING_PATH_STEPS}/${id}`
    })

    return response;
}
